<template>
    <div class="message-attachment">
        <template v-for="picture in pictures">
            <img v-if="picturesData[picture.fileId]" :key="picture.fileId" :src="picturesData[picture.fileId]" @loadstart="loadStart(pciture.fileId)">
            <div v-else class="picture-loading" :key="picture.fileId">
                <spinner></spinner>
            </div>
        </template>

        <contacts-share-atachments v-for="(contact, index) in contacts"
            @sendContacts="$emit('sendContacts')"
            :contact="contact.data"
            :isMy="isMy"
            :key="index" />

        <meetings-attachment v-if="meeting" :params="meeting" :is-my="isMy"/>
    </div>
</template>

<script>
    import Vue from "vue";
    import AttachmentsTypes from "../../../enums/AttachmentsTypes";
    import {getImage} from "../../../api/methods/files";
    import Spinner from "../../Spinner";
    import ContactsShareAtachments from "./ContactsShareAtachments"
    import MeetingsAttachment from "@share/chat/components/chat/atachments/meeting/MeetingsAttachment";

    export  default Vue.extend({
        name: "Attachments",
        components: {MeetingsAttachment, Spinner, ContactsShareAtachments},
        props: {
            attachments: {
                required: true,
                type: Array
            },
            isMy: {
                required: true,
                type: Boolean
            }
        },
        data() {
            return {
                picturesData: {},
                chatBodyElement: document.getElementById('chat-messages-list')
            }
        },
        computed: {
            pictures() {
                return this.attachments.filter(item => item.type == AttachmentsTypes.photo) || [];
            },
            contacts() {
                return this.attachments.filter(item => item.type == AttachmentsTypes.contacts) || [];
            },
            meeting() {
                return this.attachments.find(item => item.type == AttachmentsTypes.meeting);
            }
        },
        methods: {
            imgUrl(picture) {
                return getImageUrl(this.$store.state.session.backend, picture.fileId);
            },
            async loadPicture(fileId) {
                const image = await getImage(fileId);
                const mimeType = image.headers['content-type'].toLowerCase();
                const imgBase64 = new Buffer(image.data, 'binary').toString('base64');
                this.$set(this.picturesData, fileId, 'data:' + mimeType + ';base64,' + imgBase64);
            },
        },
        mounted() {
            this.pictures.forEach(item => {
                this.loadPicture(item.fileId);
            });
        }
    });
</script>

<style scoped>

</style>
